import { Customer } from 'data/firestore/agent/customer/types';
import { EntityGet } from 'data/firestore/types';
import { createContext, Dispatch, SetStateAction } from 'react';

export interface Context {
    smsChatProps: Record<string, unknown>;
    customerPanelProps: {
        isOpen?: boolean;
        data?: EntityGet<Customer>;
    },
    algoliaSecureKeys: {
        sessions?: string;
        inbox?: string;
        blockednumbers?: string;
        customers?: string;
        customers_createdAt_desc?: string;
        customers_createdAt_asc?: string;
        affiliates?: string;
        workplaces?: string;
        opportunities?: string;
        opportunities_updatedAt_desc?: string;
        opportunities_updatedAt_asc?: string
        opportunities_createdAt_desc?: string;
        opportunities_createdAt_asc?: string;
        opportunities_score_desc?: string;
        opportunities_score_asc?: string;
        // inbox_createdAt_desc?: string;
        // inbox_createdAt_asc?: string;
        // inbox_priority_desc?: string;
        // inbox_priority_asc?: string;
    },
    setAlgoliaSecureKeys: Dispatch<SetStateAction<Context['algoliaSecureKeys']>>;
}

const context = createContext<Context>({
    smsChatProps: {},
    customerPanelProps: {},
    algoliaSecureKeys: {},
    setAlgoliaSecureKeys: () => {},
});

export const { Provider, Consumer } = context;

export default context;
